module.exports = __webpack_public_path__ + "./assets/img/marketing_m.66c84e45.png";